module.exports = __webpack_public_path__ + "static/media/rate-ton.6b77c29e.svg";